import { FeatureName } from "#shared/featureAccessContract.ts";
import { CYCLES_LIST_PATH } from "../review-cycles/cycleDetailPaths.ts";

export const FEATURE_ACCESS_SEGMENT = "/access";

export const FeatureSegments = {
    engagement: "/features/engagement",
    goals: "/features/goals",
    "good-vibes": "/features/good-vibes",
    meetings: "/features/meetings",
    "performance-reviews": "/features/performance-reviews",
    plans: "/features/plans"
} as const;

export type FeatureId = keyof typeof FeatureSegments;

const featurePath = (id: FeatureId) => `/settings${FeatureSegments[id]}`;

export const PERFORMANCE_REVIEWS_ACCESS_PATH = `${featurePath("performance-reviews")}${FEATURE_ACCESS_SEGMENT}`;

export interface FeatureCatalogueEntry {
    id: FeatureId;
    featureName: FeatureName;
    rowPath: string;
    accessPath: string;
}

export const FEATURE_CATALOGUE: readonly FeatureCatalogueEntry[] = [
    { id: "engagement", featureName: FeatureName.ENGAGEMENT, rowPath: featurePath("engagement"), accessPath: `${featurePath("engagement")}${FEATURE_ACCESS_SEGMENT}` },
    { id: "goals", featureName: FeatureName.GOALS, rowPath: featurePath("goals"), accessPath: featurePath("goals") },
    { id: "good-vibes", featureName: FeatureName.RECOGNITION, rowPath: featurePath("good-vibes"), accessPath: `${featurePath("good-vibes")}${FEATURE_ACCESS_SEGMENT}` },
    { id: "meetings", featureName: FeatureName.MEETINGS, rowPath: featurePath("meetings"), accessPath: featurePath("meetings") },
    { id: "performance-reviews", featureName: FeatureName.PERFORMANCE_REVIEWS, rowPath: CYCLES_LIST_PATH, accessPath: PERFORMANCE_REVIEWS_ACCESS_PATH },
    { id: "plans", featureName: FeatureName.PLANS, rowPath: featurePath("plans"), accessPath: featurePath("plans") }
];
